import Cookie from 'js/lib/cookie';

export default {
  get(): string {
    const token = Cookie.get('CSRF3-Token');
    if (token === undefined || token === null || token.length === 0) {
      throw new Error('CSRF Token was missing or null. Please ensure that the CSRF3-Token cookie is set.');
    }

    return token;
  },
};
